import React from 'react';
import { Link } from 'react-router-dom';

const SideMenu = ({ backLink, backText, menuItems, language }) => {
  const backTextTranslated = language === 'English' ? 'Go Back to' : 'Kthehu prapa tek';
  return (
    <nav className="side-menu" aria-label={language === 'English' ? 'Main navigation' : 'Navigimi kryesor'}>
      <Link to={backLink} className="side-menu-back-link text-blue-500" aria-label={backTextTranslated}>
        ← {backTextTranslated} {backText}
      </Link>
      <ul className="mt-4">
        {menuItems.map((item) => (
          <li key={item.href} className="mb-2">
            <a href={item.href} className="hover:underline text-gray-700">{item.label}</a>
            {item.subitems && item.subitems.length > 0 && (
              <ul className="ml-4 mt-2">
                {item.subitems.map((subitem) => (
                  <li key={subitem.href} className="mb-1">
                    <a href={subitem.href} className="hover:underline text-gray-600">
                      {subitem.label}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SideMenu;